module.exports = __webpack_public_path__ + "cement/img/gongxin.4711cc55.png";